import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { SHOW_GLOBAL_LOADER } from '@shared/data-access/data-access-ui';

@Injectable({ providedIn: 'root' })
export class TranslocoLoaderService implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`, {
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
    });
  }
}
